import { Model }        from '@mathquis/modelx';
import currentSession   from 'utils/currentSession';
import { CsvConnector } from 'connectors/CsvConnector';
import ConfigProxy      from 'utils/ConfigProxy';

export const connector = new CsvConnector({
  baseURL: ConfigProxy.get('API_ENTRYPOINT'),
});

connector.setCurrentSessionStore(currentSession);

export default class CsvModel extends Model {
  static get connector() {
    return connector;
  }

  patch(attributes = {}, options = {}) {
    return this.save({ ...options, patchAttributes: attributes });
  }
}
